import Swiper from 'swiper';
import { Pagination, A11y, Keyboard } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import './_logo-list.scss';
var SECTION_SELECTOR = '[data-logo-list]';
var MARQUEE_SELECTOR = '[data-logo-list-marquee]';
var MARQUEE_LIST_SELECTOR = '.logo-list__items--marquee';
var SLIDER_SELECTOR = '[data-logo-list-swiper]';
var PAGINATION_SELECTOR = '.swiper-pagination';
var DESKTOP_MIN_WIDTH = 768;
var RESIZE_DEBOUNCE_MS = 150;
function initSection(sectionEl, index) {
  var _sectionEl$querySelec;
  var overflowBehavior = sectionEl.dataset.overflowBehavior;
  var marqueeWrapper = sectionEl.querySelector(MARQUEE_SELECTOR);
  var marqueeList = sectionEl.querySelector(MARQUEE_LIST_SELECTOR);
  var paginationSelector = ".logo-list-pagination-".concat(index);
  (_sectionEl$querySelec = sectionEl.querySelector(PAGINATION_SELECTOR)) === null || _sectionEl$querySelec === void 0 || _sectionEl$querySelec.classList.add("logo-list-pagination-".concat(index));
  var swiper = null;
  function destroySwiper() {
    if (!swiper) return;
    swiper.destroy(true, true);
    swiper = null;
  }
  function initSwiper() {
    if (swiper) return;
    var slider = sectionEl.querySelector(SLIDER_SELECTOR);
    if (!slider) return;
    swiper = new Swiper(slider, {
      modules: [Pagination, A11y, Keyboard],
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 16,
      watchOverflow: true,
      keyboard: true,
      a11y: {
        enabled: true
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3
        },
        1080: {
          slidesPerView: 5,
          slidesPerGroup: 5
        }
      },
      pagination: {
        el: paginationSelector,
        clickable: true,
        renderBullet: function renderBullet(bulletIndex, className) {
          var isActive = this.activeIndex === bulletIndex ? 'aria-current="true"' : '';
          return "<span type=\"button\" tabindex=\"0\" class=\"".concat(className, "\" ").concat(isActive, "></span>");
        }
      },
      on: {
        slideChange(swiperInstance) {
          updateActiveBullet(sectionEl, paginationSelector, swiperInstance.snapIndex || 0);
        }
      }
    });
    var paginationBullets = sectionEl.querySelectorAll("".concat(paginationSelector, " .swiper-pagination-bullet"));
    paginationBullets.forEach((bullet, bulletIndex) => {
      bullet.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          swiper.slideTo(bulletIndex * swiper.params.slidesPerGroup);
        }
      });
    });
  }
  function evaluateState() {
    var isMobile = window.innerWidth < DESKTOP_MIN_WIDTH;

    // Desktop only activates the overflow behavior once logos no longer
    // fit the viewport; otherwise it stays a plain static row. Mobile
    // always runs the configured behavior regardless of fit.
    if (!isMobile) {
      var overflows = marqueeList && marqueeWrapper ? marqueeList.scrollWidth > marqueeWrapper.clientWidth : false;
      if (!overflows) {
        sectionEl.classList.remove('is-marquee', 'is-slider');
        destroySwiper();
        return;
      }
    }
    if (overflowBehavior === 'slider') {
      sectionEl.classList.remove('is-marquee');
      sectionEl.classList.add('is-slider');
      initSwiper();
    } else {
      sectionEl.classList.remove('is-slider');
      sectionEl.classList.add('is-marquee');
      destroySwiper();
    }
  }
  evaluateState();
  var resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(evaluateState, RESIZE_DEBOUNCE_MS);
  });
}
function updateActiveBullet(sectionEl, paginationSelector, activePageIndex) {
  var bullets = sectionEl.querySelectorAll("".concat(paginationSelector, " .swiper-pagination-bullet"));
  bullets.forEach((bullet, bulletIndex) => {
    if (bulletIndex === activePageIndex) {
      bullet.setAttribute('aria-current', 'true');
    } else {
      bullet.removeAttribute('aria-current');
    }
  });
}
document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
document.addEventListener('shopify:section:load', e => {
  var sectionEl = e.target.querySelector(SECTION_SELECTOR);
  if (sectionEl) initSection(sectionEl, document.querySelectorAll(SECTION_SELECTOR).length);
});